import { Absence, AbsenceFilters } from "@myapp/contract";
import { useInfinitePaginated } from "../../../../shared/hooks/useInfinitePaginated";
import { absenceKeys } from "../absence.keys";
import { absenceApi } from "../service";

export function useAbsenceInfiniteQuery(filters: AbsenceFilters) {
  return useInfinitePaginated<AbsenceFilters, Absence>({
    queryKey: absenceKeys.list(filters),
    params: filters,
    fetchFn: ({ page, ...rest }) =>
      absenceApi.search({ ...rest, page }).then((response) => response.data),
    retry: false,
  });
}
